import { render, staticRenderFns } from "./NxFooter.vue?vue&type=template&id=50664844&scoped=true&"
import script from "./NxFooter.vue?vue&type=script&lang=js&"
export * from "./NxFooter.vue?vue&type=script&lang=js&"
import style0 from "./NxFooter.vue?vue&type=style&index=0&id=50664844&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50664844",
  null
  
)

export default component.exports